import React from 'react';
import { Button } from '@mui/material';

/**
 * The primary CTA of every AI drawer.
 *
 * Shaped after the login button (views/Login/LoginStyles.js `submit`) — same
 * 12px radius, same lift on press — but a size down from it. That one is a
 * full-page hero action with nothing to compete with; this one sits under a
 * form, and at login's 48px/18px/600 it read as the loudest thing in the
 * drawer. Same family, quieter voice.
 *
 * Two further departures, both about what a shared button has to survive:
 *
 *  - `minHeight` rather than a fixed `height`. These labels are translated, and
 *    「推薦適合的產品」 becomes "Recommend suitable products" — a fixed height
 *    clips a wrapped label instead of growing for it.
 *  - No `var(--my-gradient)` background. A background set here would paint over
 *    MUI's disabled state, and two of these CTAs (活動推薦, 方案配對) are
 *    disabled until the adviser picks a life stage. The shadow is dropped on
 *    disabled for the same reason: a greyed button should not float.
 */
const Style = {
  padding: '6px 16px',
  borderRadius: 12,
  minHeight: 40,
  width: '100%',
  fontSize: 15,
  fontWeight: 500,
  textTransform: 'none'
};

const Sx = {
  boxShadow: '0 4px 14px 0 rgba(57, 102, 248, 0.25)',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-1px)',
    boxShadow: '0 6px 20px 0 rgba(57, 102, 248, 0.35)'
  },
  '&:active': {
    transform: 'translateY(0px)'
  },
  '&.Mui-disabled': {
    boxShadow: 'none'
  }
};

const ActionButton = props => {
  const { style, sx, children, variant = 'contained', ...rest } = props;
  return (
    <Button color="primary" variant={variant} style={{ ...Style, ...style }} sx={{ ...Sx, ...sx }} {...rest}>
      {children}
    </Button>
  );
};

export default ActionButton;
